<template>
  <div :class="classes">
    <slot name="icon">
      <rt-icon :name="icon" :img-src="iconSrc" :color="iconColor"></rt-icon>
    </slot>
    <span class="rt-tag-text"> <slot /> </span>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
export default {
  name: 'RtTag',
  components: {
    RtIcon
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconColor: String,
    colorType: {
      type: String,
      default: 'info'
    },
    iconSrc: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes() {
      return ['rt-tag', `rt-tag-${this.colorType}`];
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtTag.vue?4abf5e8c